import { debounce } from 'lodash';

export default {
    computed: {
        options() {
            return this.getChargebeeCatalogue[this.getPlanSelected]?.addons.options;
        },
    },
    methods: {
        callError(error = '') {
            console.error(error);
            this.$pushToast({
                type: 'error',
                icon: true,
                text: this.$l10n.__('Une erreur est survenue, merci de contacter le support'),
                close: true,
            });
            this.displayPreload = false;
        },
        humanizeCentsPrice(amount) {
            return amount !== 0 ? amount / 100 : 0;
        },
        recurrencyLabel(period) {
            return period === 'year' ? this.$l10n.__('an') : this.$l10n.__('mois');
        },
        updateOption: debounce(async function (option, enabledOption) {
            try {
                await this.updateOptionStatus({ optionNameKey: option, value: enabledOption });
            } catch (e) {
                this.callError(e);
            }
        }, 200),
        isOptionEnabled(key) {
            return (
                this.getSubscriptionItems.find((option) => option.nameKey === key)?.quantity > 0 ??
                false
            );
        },
    },
};
